export enum IDTypologyConsent {
  Consenso2 = '2',
  Consenso3 = '3',
  Consenso4 = '4',
}
